import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import type { To } from 'react-router';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useSafePreviousNavigate } from '@sorare/core/src/hooks/useSafePreviousNavigate';
import { glossary } from '@sorare/core/src/lib/glossary';
import { generateSportPath } from '@sorare/core/src/lib/routing/generateSportPath';
import {
  laptopAndAbove,
  mediumDesktopAndAbove,
} from '@sorare/core/src/style/mediaQuery';

const Wrapper = styled(Horizontal)`
  margin-bottom: var(--unit);
  @media ${laptopAndAbove} {
    padding: var(--unit);
    margin: 0;
  }
`;

const ButtonLabel = styled.p`
  display: none;
  @media ${mediumDesktopAndAbove} {
    display: block;
  }
`;

type Props = {
  safePath?: To;
};

export const BackButton = ({ safePath }: Props) => {
  const { sport } = useSportContext();
  const navigateSafePrevious = useSafePreviousNavigate(
    safePath || generateSportPath('', { sport })
  );

  return (
    <Wrapper>
      <Button
        color="tertiary"
        size="medium"
        role="button"
        startIcon={<FontAwesomeIcon icon={faChevronLeft} />}
        onClick={navigateSafePrevious}
      >
        <ButtonLabel>
          <FormattedMessage {...glossary.back} />
        </ButtonLabel>
      </Button>
    </Wrapper>
  );
};
